import React from 'react';
import cx from 'classnames';

import styles from './SectionContentsBody.module.scss';
import SectionContentsBodyHeader from './SectionContentsBodyHeader';

function SectionContentsBody({children, className, ...rest}) {
  return (
    <div className={cx(styles['content'], className)}>
      <SectionContentsBodyHeader {...rest} />
      {children && <div className={styles['content--body']}>{children}</div>}
    </div>
  );
}

export default SectionContentsBody;
